module.exports = __webpack_public_path__ + "img/4.19727128.png";